var _rect, _path, _path2, _polygon, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEarlyMorning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.09,368.51a40.91,40.91,0,0,0-17.45-6c-2.86-.29-6-.21-8.26,1.52a1.71,1.71,0,0,0-.85,1.51,1.82,1.82,0,0,0,.81,1c7.1,5.41,17.84,6.1,25.75,1.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.64,368a84.43,84.43,0,0,1-11.27-9.91A28.5,28.5,0,0,1,93.3,345c-.3-1.49-.4-3.19.56-4.37,9,7,16,16.09,17.78,27.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,368.44a40.89,40.89,0,0,1,.21-14.8c1.13-4.83,3.76-9.45,7.88-12.21,1.56,3.63.89,7.81-.2,11.6a56.74,56.74,0,0,1-7.82,16.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,384.22c-5.35.65-10,3.47-14,7.08a26.49,26.49,0,0,0-8,13.75c5.24-.33,9.69-4,12.92-8.17s5.46-8.7,9-12.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.71,386.75a34.54,34.54,0,0,1,4-32.65c3,10.83,1.93,23.07-4,32.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.35,400.6a24.94,24.94,0,0,0-23.86,13.74c-.3.59-.56,1.34-.17,1.87a1.78,1.78,0,0,0,1.59.46c4.7-.3,8.87-3.13,12.31-6.35s6.43-6.95,10.23-9.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,399.85a44.43,44.43,0,0,1-.45-24.83c.88-3.2,2.35-6.56,5.3-8.06a1,1,0,0,1,.81-.14,1.08,1.08,0,0,1,.52.59,15,15,0,0,1,1.24,7.12,44.22,44.22,0,0,1-1.11,7.22c-.93,4.4-1.43,9.14-3.84,12.94a26,26,0,0,0-1.54,2.84c-.46,1-.46,1.31-.88,2.08",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.78,404.44c-2.28-8.68.14-19.21,5.61-26.32.4-.53.94-1.09,1.6-1,1,.09,1.26,1.44,1.22,2.45a47.65,47.65,0,0,1-8.43,24.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.56,406.33c10.54,2.75,22.64.08,31.41-6.39a25.43,25.43,0,0,0-17-2.08c-5.68,1.3-10.88,3.84-14.41,8.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.9,400.55c5.91-9.63,17.23-15.91,28.51-16.48-1.3,4.59-5.07,8.15-9.32,10.31s-9,3.09-13.69,4c-1.82.35-4.32.74-5.5,2.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.37,372.51c1.6-5.48,3.2-11,3.64-16.7s-.37-11.63-3.32-16.52c-5.52,10.68-6.08,23.15-.49,33.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.94,363.12c6.45-11.73,19.62-21.09,32.94-22.41-5.14,12.8-19.15,22.68-32.94,22.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.88,365.42c9.63,1.46,17.82,7.61,26.82,11.33a12,12,0,0,0,6.06,1.17,4.75,4.75,0,0,0,3-8.4,13,13,0,0,0-4.4-2.67c-9.8-4.08-20.3-4.18-30.62-1.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.32,372.17c2.17.62,2.92,1.75,4.64,3.22a50.23,50.23,0,0,0,20.34,10.44c.77.2,1.79.27,2.18-.43s-.09-1.35-.53-1.9a28,28,0,0,0-12.28-8.34c-4.69-1.74-8.75-3.85-14.35-3.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,331.4a38.45,38.45,0,0,0,29.5,10,2,2,0,0,0,1.35-.48c.74-.81-.15-2-1-2.73-8.67-6.76-19.18-9.57-29.83-6.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,328.68a41.1,41.1,0,0,1,36.81-6.08c-4.63,4.57-11.06,7-17.54,7.71a55.71,55.71,0,0,1-19.27-1.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,310c-.85-8.66-.3-15.49-.9-24.19-.05-.7-.2-1.53-.85-1.78-.9-.35-1.66.76-2,1.68a27.74,27.74,0,0,0,3.69,24.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,310.9c5.87-3.62,10.27-8.36,14.34-13.93,2.83-3.88,5.22-8.52,4.57-13.28-4-.08-7.75,2.11-10.34,5.14a28.81,28.81,0,0,0-5.27,10.61c-1.15,3.81-2,7.72-3.3,11.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,307a115.74,115.74,0,0,0,35.29-20.81c-4.22-1.7-9-.68-13.26,1-9.63,3.89-17.49,10.45-22.22,19.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.86,315.64c6.51.71,13.13,1.18,19.6.1s12.35-3.58,18.29-6.08a2.14,2.14,0,0,0,1.24-1,1.41,1.41,0,0,0-.44-1.56,3.68,3.68,0,0,0-1.56-.73c-6.46-1.81-13.42-1-19.77,1.18a91.42,91.42,0,0,0-17.36,8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.66,331.7c-4.45-9-4.16-19.44-.32-28.69,2.7,4.12,3,9.36,2.54,14.27s-2,9.94-2.08,14.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,322.74a40,40,0,0,0-29.73,12.67c5.54.87,11.24-.56,16.28-3s9.51-5.91,14-9.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,318.75c-5.43-.44-10.65-1.11-15.87.49s-10,5.23-12.1,10.26a28.68,28.68,0,0,0,14.88-2.81A84.86,84.86,0,0,0,109,318.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,318.93c-4.88-3.2-9.9-6.45-15.59-7.78s-12.27-.35-16.24,3.94c4.6,2.7,10.19,3,15.53,3s11.88-.07,16.91,1.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,319.19c-8.35-8.2-11.52-22.92-8.16-34.13a51.94,51.94,0,0,1,8.16,34.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,296c1.57-3.66,2.68-7.5,4.09-11.23a32.47,32.47,0,0,1,5.84-10.35A15.38,15.38,0,0,1,169.9,269a41.64,41.64,0,0,1-20.07,27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.47,300.8c-2.6-3.58-5.61-8.45-9.15-11.13s-8.13-4.3-12.45-3.27a29,29,0,0,0,21.6,14.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3,296.26c-1.7-4.34-3.42-8.73-4.12-13.34s-.27-9.54,2.09-13.56c4.59,8.66,6.06,18,2.27,27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,269.36c2.6-8.59,10.46-14.92,19-17.82a7.19,7.19,0,0,1,3.32-.5,2.89,2.89,0,0,1,2.45,2.05c.31,1.46-.89,2.77-2,3.74a64.63,64.63,0,0,1-22.69,12.53",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.76,262.33c.33-5.53.68-11.15,2.48-16.4s5.27-10.17,10.32-12.46c.86,5.59-1.61,11.15-4.58,16s-6.56,9.35-8.35,14.72",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,266.15c-2.15-6.26-2.37-14.21-6.12-19.67-2.62-3.81-6.81-6.41-9.07-10.44a15.86,15.86,0,0,0,.53,11.85,34.3,34.3,0,0,0,6.93,9.93c2.77,3,5.15,5.19,7.73,8.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,450.48c-.17,0-.31-41.76-.32-93.25s.11-93.27.28-93.27.31,41.75.32,93.27S149.84,450.48,149.67,450.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,325.4a8.9,8.9,0,0,1-1.57.59l-4.32,1.46c-3.64,1.24-8.65,3-14.08,5.26s-10.45,4.18-13.34,6.68a9.93,9.93,0,0,0-2.68,3.55c-.41,1-.49,1.58-.54,1.57s0-.15,0-.44a6.54,6.54,0,0,1,.3-1.22,9.46,9.46,0,0,1,2.62-3.78,23.37,23.37,0,0,1,5.79-3.59c2.31-1.08,4.88-2.21,7.6-3.33,5.45-2.23,10.49-4,14.18-5.11,1.84-.57,3.34-1,4.38-1.28A9,9,0,0,1,186.16,325.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,296a2.57,2.57,0,0,1-.44.47l-1.34,1.26-5,4.54-16.65,14.83c-6.5,5.78-12.12,11.31-16,15.47-2,2.08-3.48,3.8-4.53,5L152.94,339c-.28.32-.43.48-.45.46a2.73,2.73,0,0,1,.36-.53c.25-.34.62-.84,1.12-1.46,1-1.25,2.48-3,4.4-5.14a211.09,211.09,0,0,1,15.92-15.63c6.52-5.77,12.45-11,16.77-14.7l5.12-4.4,1.42-1.17A3.63,3.63,0,0,1,198.12,296Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.67,323c-.17-.08,1.19-3.21,2.54-7.18s2-7.31,2.18-7.28-.22,3.46-1.6,7.48a49.92,49.92,0,0,1-2,5A7.57,7.57,0,0,1,167.67,323Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.71,348.27a6.67,6.67,0,0,1-1-1.16l-2.57-3.29C144,341,141,337.19,137.67,333s-6.41-8-8.64-10.71L126.41,319a7.28,7.28,0,0,1-.9-1.24,8.26,8.26,0,0,1,1.08,1.09c.67.72,1.62,1.79,2.77,3.12,2.31,2.67,5.43,6.4,8.78,10.62s6.27,8.1,8.34,10.95c1,1.43,1.86,2.6,2.42,3.41A8.69,8.69,0,0,1,149.71,348.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.71,338c-.1.11-2.24-2.43-3.35-6.27a17.65,17.65,0,0,1-.76-6.33l.26,0c-.12.49-.21.74-.25.73s-.05-.27,0-.77l.26,0a29,29,0,0,0,1.07,6.15C140,335.28,141.87,337.9,141.71,338Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.38,325a11,11,0,0,0-2.34-1.36,15.6,15.6,0,0,0-6.5-.52,39.65,39.65,0,0,0-6.54,1.06,18.08,18.08,0,0,1-2.69.64,9.44,9.44,0,0,1,2.57-1.05,29.47,29.47,0,0,1,6.61-1.25,14.24,14.24,0,0,1,6.71.72A4.15,4.15,0,0,1,131.38,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.93,321.86c-.05.09-1.36-.55-3.59-1.31a36,36,0,0,0-18.06-1.37c-2.32.41-3.71.84-3.75.74a3.52,3.52,0,0,1,1-.4,22.7,22.7,0,0,1,2.71-.76,31.89,31.89,0,0,1,18.3,1.39,23.59,23.59,0,0,1,2.56,1.16C128.64,321.63,129,321.82,128.93,321.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.63,308.54c-.16,0-1.33-4-2.62-9.08s-2.19-9.19-2-9.23,1.34,4,2.62,9.08S149.79,308.5,149.63,308.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.79,308.54c-.18.06-.93-2.66-2.89-5.43a24.23,24.23,0,0,0-4.27-4.41,4.12,4.12,0,0,1,1.65.85,13.29,13.29,0,0,1,3.11,3.21C149.43,305.65,149.94,308.53,149.79,308.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,428.22c-.07,0-.19-1-.66-2.78a39.16,39.16,0,0,0-2.79-7.23c-2.88-5.89-8.13-13.37-14.8-20.85-3.31-3.78-6.52-7.34-9.24-10.75a76.92,76.92,0,0,1-6.6-9.53,45.72,45.72,0,0,1-3.33-7.06c-.31-.87-.53-1.55-.66-2a3.45,3.45,0,0,1-.17-.73s.36,1,1,2.66a50.34,50.34,0,0,0,3.48,6.94,79.56,79.56,0,0,0,6.67,9.39c2.73,3.37,5.94,6.92,9.25,10.7,6.69,7.51,11.93,15.08,14.74,21.07a36.15,36.15,0,0,1,2.63,7.36c.19.9.32,1.61.37,2.09A3.42,3.42,0,0,1,149.67,428.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64,391a17.09,17.09,0,0,1-1.72,1,37.17,37.17,0,0,0-4.49,3,51.55,51.55,0,0,0-5.88,5.37c-2.07,2.18-4.2,4.72-6.37,7.43-4.34,5.45-8.41,10.27-10.84,14.12-1.23,1.91-2.13,3.52-2.72,4.65a14.74,14.74,0,0,1-1,1.74,1.72,1.72,0,0,1,.16-.49c.13-.31.3-.78.58-1.35A44.6,44.6,0,0,1,153,421.6c2.36-3.94,6.39-8.83,10.73-14.27,2.18-2.72,4.33-5.26,6.43-7.44a47.84,47.84,0,0,1,6-5.32,30.37,30.37,0,0,1,4.63-2.83c.57-.29,1-.47,1.34-.6A1.45,1.45,0,0,1,182.64,391Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,403.06a24.42,24.42,0,0,1-3.65.53A48.15,48.15,0,0,0,171,405.3a25.74,25.74,0,0,0-7.75,4.07c-1.79,1.38-2.63,2.52-2.72,2.45A2.92,2.92,0,0,1,161,411a13.93,13.93,0,0,1,1.91-2,23.38,23.38,0,0,1,7.84-4.31,39.66,39.66,0,0,1,8.8-1.56A20.19,20.19,0,0,1,183.29,403.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,410.5c-.19-.11,1.45-2.63,2.73-6s1.48-6.4,1.69-6.37a5.58,5.58,0,0,1-.06,2,21.09,21.09,0,0,1-1.06,4.62,22.63,22.63,0,0,1-2.12,4.23A5.92,5.92,0,0,1,161.57,410.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,358.54a2.33,2.33,0,0,1-.58.31l-1.72.78c-.75.32-1.66.73-2.69,1.27s-2.24,1.08-3.49,1.84l-2,1.13c-.7.4-1.38.87-2.11,1.32-1.47.9-2.94,2-4.51,3.11a85.76,85.76,0,0,0-9.41,8.29,83.5,83.5,0,0,0-8,9.69c-1.07,1.61-2.11,3.12-3,4.62-.43.74-.87,1.44-1.25,2.14s-.72,1.39-1.06,2c-.71,1.28-1.22,2.51-1.71,3.55s-.89,2-1.19,2.74L150,403.1a2.94,2.94,0,0,1-.29.6,2.48,2.48,0,0,1,.18-.64l.62-1.79a29.82,29.82,0,0,1,1.09-2.78c.47-1.07,1-2.31,1.64-3.61l1-2.06c.37-.71.81-1.42,1.23-2.18.83-1.52,1.87-3,2.93-4.67a74.53,74.53,0,0,1,17.5-18.11c1.59-1.12,3.09-2.21,4.58-3.09.73-.45,1.43-.91,2.13-1.3l2-1.11c1.28-.73,2.5-1.26,3.55-1.76a29.75,29.75,0,0,1,2.75-1.19l1.76-.67A2.71,2.71,0,0,1,193.32,358.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,376a4.06,4.06,0,0,1,1.43-2.13,9,9,0,0,1,5.78-2.22,15.79,15.79,0,0,1,6.09,1.19,8.93,8.93,0,0,1,2.3,1.11,12.88,12.88,0,0,1-2.44-.71,18.64,18.64,0,0,0-5.93-1,9.39,9.39,0,0,0-5.52,1.94A15.47,15.47,0,0,0,167.23,376Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.33,380.05c-.17-.09,1.3-2.25,1.64-5.34s-.55-5.53-.37-5.58.39.54.68,1.56a11.16,11.16,0,0,1,.29,4.09,11,11,0,0,1-1.23,3.91C163.83,379.61,163.38,380.09,163.33,380.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.83,434.2c.9,16,5.71,32.19,13.11,48.6H166.1c7.05-16.25,11.53-32.45,12.33-48.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,460c0,.17-10.59.31-23.65.31s-23.65-.14-23.65-.31,10.59-.3,23.65-.3S173.21,459.86,173.21,460Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,465.81c0,.16-9.92.3-22.17.3s-22.17-.14-22.17-.3,9.92-.31,22.17-.31S172.49,465.64,172.49,465.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.45,444.68c.17,0,.31,3.32.31,7.41s-.14,7.41-.31,7.41a91.66,91.66,0,0,1,0-14.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,444.68a98.2,98.2,0,0,1,0,15.34c-.17,0-.3-3.43-.3-7.67S151.52,444.68,151.69,444.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.87,444.55a102.2,102.2,0,0,1,0,15.65c-.17,0-.31-3.5-.31-7.83S167.7,444.55,167.87,444.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,444.68c0,.17-12.42.3-27.74.3s-27.74-.13-27.74-.3,12.42-.3,27.74-.3S177.4,444.51,177.4,444.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.09,
    y: 45.74,
    width: 236.25,
    height: 216.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.14,
    y: 53.87,
    width: 216.02,
    height: 199.94,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 545.13,
    y: 50.14,
    width: 5.59,
    height: 203.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.61,129.47l1.31.72-1.32.71a4.23,4.23,0,0,0-1.63,1.62l-.72,1.31-.71-1.31a4.06,4.06,0,0,0-1.62-1.64l-1.31-.72,1.32-.71a4.1,4.1,0,0,0,1.63-1.62l.72-1.3.71,1.31A4.1,4.1,0,0,0,647.61,129.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.23,126.53l.52.29-.52.28a1.67,1.67,0,0,0-.65.64l-.28.52-.28-.52a1.67,1.67,0,0,0-.64-.65l-.52-.28.52-.28a1.67,1.67,0,0,0,.65-.64l.28-.52.28.52A1.64,1.64,0,0,0,550.23,126.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 99.18,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 84.87,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 70.57,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 56.27,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 41.97,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 168.78,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 154.48,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 140.18,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 125.87,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.58,
    y: 111.57,
    width: 254.71,
    height: 7.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.92,
    y: 56.76,
    width: 9.01,
    height: 44.85,
    transform: "translate(-0.42 1.75) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.79,
    y: 56.91,
    width: 23.34,
    height: 24.76,
    transform: "translate(-0.37 1.36) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.02,
    y: 56.79,
    width: 23.34,
    height: 24.76,
    transform: "translate(-0.37 1.49) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,63.81c15.51.13,31.06,0,46.57-.21a.25.25,0,0,0,0-.5c-15.51-.08-31.05,0-46.56.29a.21.21,0,0,0,0,.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.23,
    y: 81.31,
    width: 42.4,
    height: 20.18,
    transform: "translate(-0.49 1.34) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.43,
    y: 81.08,
    width: 42.4,
    height: 20.18,
    transform: "translate(-0.48 1.56) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,87c28.17.32,56.44,0,84.61-.41a.25.25,0,0,0,0-.5c-28.17-.15-56.44-.13-84.6.49a.21.21,0,0,0,0,.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.35,
    y: 101.6,
    width: 164.28,
    height: 7.23,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.24,
    y: 105.07,
    width: 6.67,
    height: 24.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.8,
    y: 105.07,
    width: 6.67,
    height: 24.66,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.76,
    y: 40.04,
    width: 9.01,
    height: 61.68,
    transform: "translate(-0.38 1.79) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.82,
    y: 51.53,
    width: 14,
    height: 49.98,
    transform: "translate(-0.41 1.86) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,61.12a49,49,0,0,1-7,.25,49,49,0,0,1-7-.25,51.82,51.82,0,0,1,7-.24A51.91,51.91,0,0,1,352.6,61.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,59a49,49,0,0,1-7,.25,49,49,0,0,1-7-.25,51.82,51.82,0,0,1,7-.24A51.91,51.91,0,0,1,352.6,59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,94a51.91,51.91,0,0,1-7,.24,51.82,51.82,0,0,1-7-.24,49,49,0,0,1,7-.25A49,49,0,0,1,352.6,94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,91.86a51.91,51.91,0,0,1-7,.24,51.82,51.82,0,0,1-7-.24,49,49,0,0,1,7-.25A49,49,0,0,1,352.6,91.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.82,87.27c-.14,0-.24-5-.24-11.26s.1-11.26.24-11.26.24,5,.24,11.26S346,87.27,345.82,87.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.75,
    y: 63.77,
    width: 15.24,
    height: 37.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.56,50.54A2.59,2.59,0,1,1,334,48,2.59,2.59,0,0,1,336.56,50.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.17,
    y: 57.67,
    width: 1.6,
    height: 36.69,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.47,481.41c0,.14-152.45.26-340.45.26s-340.49-.12-340.49-.26,152.41-.26,340.49-.26S715.47,481.27,715.47,481.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Nightstand--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.52,
    y: 337.05,
    width: 125.14,
    height: 95.19,
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 624.74,
    y: 337.05,
    width: 68.92,
    height: 95.19
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "606.32 432.24 590.53 481.41 595.15 481.41 617.2 432.24 606.32 432.24",
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.26 432.24 679.05 481.41 674.42 481.41 652.38 432.24 663.26 432.24",
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.71,432.7c0,.15-28.19.26-62.94.26s-62.95-.11-62.95-.26,28.18-.26,62.95-.26S694.71,432.56,694.71,432.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622,362.28a1.59,1.59,0,0,1,0-.38c0-.26,0-.62,0-1.07,0-1,0-2.33-.05-4.08,0-3.55-.06-8.63-.1-14.92l.19.18-51,.08c-.24.23.31-.32.25-.26h0v10.5c0,3.43,0,6.75,0,9.94L571,362l36.5.12,10.63.07,2.86,0,.74,0H622a1.1,1.1,0,0,1-.24,0h-.71l-2.81,0-10.57.07-36.67.12h-.25V352.34c0-1.71,0-3.44,0-5.2v-5.3h0c-.06.05.5-.5.27-.26l51,.07h.18v.19c0,6.33-.08,11.46-.1,15,0,1.73,0,3.09-.05,4,0,.44,0,.78,0,1S622,362.29,622,362.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.58,351.67c-.05,0-.06-.28-.2-.73a3,3,0,0,0-1.12-1.56,2.91,2.91,0,0,0-2.7-.36,2.84,2.84,0,1,0,2.7,4.93,3,3,0,0,0,1.12-1.56c.14-.45.15-.72.2-.72a1.39,1.39,0,0,1,0,.77,3,3,0,0,1-1.1,1.8,3.19,3.19,0,0,1-3.08.52,3.28,3.28,0,0,1,0-6.19,3.21,3.21,0,0,1,3.08.52,3,3,0,0,1,1.1,1.81A1.42,1.42,0,0,1,599.58,351.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.34,397s-.05-.27-.19-.72a3.07,3.07,0,0,0-1.13-1.56,2.84,2.84,0,0,0-4.53,2.28,2.83,2.83,0,0,0,1.83,2.65,2.91,2.91,0,0,0,2.7-.36,3.09,3.09,0,0,0,1.13-1.57c.14-.45.15-.72.19-.72a1.31,1.31,0,0,1,0,.77,3,3,0,0,1-1.09,1.81,3.25,3.25,0,0,1-3.09.52,3.28,3.28,0,0,1,0-6.2,3.25,3.25,0,0,1,3.09.52,3,3,0,0,1,1.09,1.81C619.43,396.7,619.37,397,619.34,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.57,425.55s0-.1,0-.28,0-.48,0-.83c0-.74,0-1.8,0-3.17,0-2.79,0-6.84-.06-12,0-10.28-.07-24.89-.12-42.32l.23.23-50.54,0h0l.26-.26c0,21.61,0,41.75,0,58.58l-.22-.21,36.63.11,10.26.06,2.71,0,1,0-.9,0-2.67,0-10.21.06-36.77.11h-.22v-.22c0-16.83,0-37,0-58.58v-.26H571l50.54,0h.23V367c0,17.49-.09,32.15-.11,42.47,0,5.11-.05,9.15-.06,11.92,0,1.36,0,2.41,0,3.14,0,.33,0,.6,0,.79A.92.92,0,0,1,621.57,425.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.52,
    y: 56.32,
    width: 120.96,
    height: 156.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,56.32a2.56,2.56,0,0,1-.33.42l-1,1.17L176,62.38l-.05.06h-.07c-10.52.11-31.18.18-54.9.18s-44.39-.07-54.9-.18H66l0-.06-4.08-4.47-1-1.17a2.56,2.56,0,0,1-.33-.42,3,3,0,0,1,.4.35L62,57.78l4.2,4.37-.12,0c10.51-.11,31.17-.18,54.9-.18s44.38.07,54.9.18l-.13,0L180,57.78l1.1-1.11C181.33,56.43,181.46,56.31,181.48,56.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,212.54a2.56,2.56,0,0,1,.33-.42l1-1.17L66,206.47l0-.05h.08c10.51-.11,31.18-.18,54.9-.18s44.38.07,54.9.18H176l.05.05,4.09,4.48,1,1.17a2.56,2.56,0,0,1,.33.42s-.15-.11-.4-.36l-1.1-1.11-4.21-4.36.13,0c-10.52.11-31.18.18-54.9.18s-44.39-.07-54.9-.18l.12,0L62,211.07l-1.1,1.11A2.25,2.25,0,0,1,60.52,212.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 62.27,
    width: 109.8,
    height: 144.32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.28,165.14c3.27-3.11,8.09-4,12.6-3.88s9,1.06,13.48,1c7.22-.09,14.4-2.76,21.51-1.53,2.27.39,4.57,1.18,6.83.7,2-.42,3.63-1.77,5.57-2.34,5-1.49,10.64,2.42,15.45.38v32.21H83.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S85,165.68,84.8,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S88.43,165.68,88.23,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62S92,99.52,92,123.06,91.86,165.68,91.67,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S95.3,165.68,95.1,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S98.73,165.68,98.54,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S102.16,165.68,102,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.41,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S105.6,165.68,105.41,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.84,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S109,165.68,108.84,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28,165.68c-.2,0-.36-19.08-.36-42.62s.16-42.62.36-42.62.35,19.08.35,42.62S112.47,165.68,112.28,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.71,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S115.9,165.68,115.71,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.14,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S119.34,165.68,119.14,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.58,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S122.77,165.68,122.58,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S126.21,165.68,126,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S129.64,165.68,129.45,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.88,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S133.08,165.68,132.88,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S136.51,165.68,136.32,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S140,165.68,139.75,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S143.38,165.68,143.19,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.62,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S146.81,165.68,146.62,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.06,165.68c-.2,0-.35-19.08-.35-42.62s.15-42.62.35-42.62.35,19.08.35,42.62S150.25,165.68,150.06,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.49,165.68c-.19,0-.35-19.08-.35-42.62s.16-42.62.35-42.62.35,19.08.35,42.62S153.68,165.68,153.49,165.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.93,165.68c-.2,0-.36-19.08-.36-42.62s.16-42.62.36-42.62.35,19.08.35,42.62S157.12,165.68,156.93,165.68Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.24,
    y: 291.69,
    width: 3.18,
    height: 1.4,
    transform: "translate(-37.17 92.86) rotate(-8.64)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.85,
    y: 292.63,
    width: 0.69,
    height: 4.32,
    transform: "translate(-37.53 92.94) rotate(-8.64)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.43 326.83 587.48 331.14 588.68 331.78 591.48 328.58 588.43 326.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.15 325.93 611.9 328.25 612.9 327.33 610.81 323.63 608.15 325.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.9,
    y: 292.68,
    width: 2.13,
    height: 1.55,
    transform: "translate(-65.26 369.4) rotate(-33.4)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.48,
    y: 295.63,
    width: 1.25,
    height: 4.78,
    transform: "translate(-67.25 371.88) rotate(-33.4)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.31,
    y: 290.09,
    width: 2.13,
    height: 1.55,
    transform: "translate(213.35 -256.05) rotate(28.58)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 606.52,
    y: 293.53,
    width: 1.25,
    height: 4.78,
    transform: "translate(215.52 -254.38) rotate(28.58)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.92,
    cy: 312.52,
    r: 17.4,
    transform: "translate(33.79 682.56) rotate(-60.86)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.13,309.91a28.4,28.4,0,0,0-1.27-4.08,16.78,16.78,0,0,0-2.61-4.25,17.54,17.54,0,0,0-5.08-4.16,17.17,17.17,0,0,0-16.45,0,16.66,16.66,0,0,0-3.94,3,19.44,19.44,0,0,0-1.67,1.93,19.08,19.08,0,0,0-1.36,2.22,17.1,17.1,0,0,0,3,20,19.67,19.67,0,0,0,2,1.71,19,19,0,0,0,2.17,1.35,16.5,16.5,0,0,0,4.65,1.66,17.39,17.39,0,0,0,9-.6A17.36,17.36,0,0,0,613.9,319a16.79,16.79,0,0,0,1.23-4.83,27.52,27.52,0,0,0,0-4.27.84.84,0,0,1,0,.27c0,.22.07.49.11.83a8.25,8.25,0,0,1,.1,1.34,13.39,13.39,0,0,1-.06,1.85,16.43,16.43,0,0,1-1.16,4.92,17.54,17.54,0,0,1-19.7,10.69,16.76,16.76,0,0,1-4.78-1.69,20.15,20.15,0,0,1-2.24-1.38,20.86,20.86,0,0,1-2-1.76,17.54,17.54,0,0,1-3.13-20.64,19.61,19.61,0,0,1,1.4-2.28,18.31,18.31,0,0,1,1.73-2,16.65,16.65,0,0,1,4.06-3,17.75,17.75,0,0,1,9-2.12,17.54,17.54,0,0,1,12.93,6.48,16.29,16.29,0,0,1,2.58,4.35,12.08,12.08,0,0,1,.6,1.74,9.65,9.65,0,0,1,.31,1.32l.14.82A1,1,0,0,1,615.13,309.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 597.83,
    cy: 312.54,
    r: 15.63,
    transform: "translate(-49.33 502.98) rotate(-44)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.8,328.67a16.13,16.13,0,1,1,16-18.56h0a16.13,16.13,0,0,1-13.53,18.37A15.65,15.65,0,0,1,597.8,328.67Zm0-31.27a14.6,14.6,0,0,0-2.28.18,15.15,15.15,0,0,0-12.69,17.23,15.13,15.13,0,1,0,29.92-4.55h0A15.16,15.16,0,0,0,597.84,297.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.48,313.33c0,.19.22,4.39.22,4.39l.92,3.52.24-3.79-.64-4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.8,310.94l5.92-4,2.54-2.6-3.37,1.74-5.57,4.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.69,311.32a1.93,1.93,0,1,1-2.19-1.61A1.93,1.93,0,0,1,599.69,311.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.92,301.81s-2.53-4.28,3-8.13,8.93-.29,8.93-.29Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.92,301.81a8.64,8.64,0,0,1,.92-.74c.67-.49,1.5-1.12,2.49-1.86,2.11-1.55,5-3.68,8.32-6l0,.39a5.31,5.31,0,0,0-1.88-1.1,7.12,7.12,0,0,0-6.05,1,9.11,9.11,0,0,0-3.64,3.67,5.48,5.48,0,0,0-.47,3.42c.15.83.39,1.25.35,1.27a2.59,2.59,0,0,1-.55-1.22,5.45,5.45,0,0,1,.33-3.63,9.37,9.37,0,0,1,3.73-3.92,9,9,0,0,1,3-1.25,6.41,6.41,0,0,1,3.49.19,5.6,5.6,0,0,1,2.08,1.23l.22.21-.25.18c-3.41,2.41-6.46,4.49-8.61,6l-2.53,1.7A7,7,0,0,1,579.92,301.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.6,292s2.59-4.24,8.57-1.21,4.44,7.74,4.44,7.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.6,292a10.19,10.19,0,0,1,1.09.47l2.81,1.33c2.36,1.12,5.6,2.68,9.23,4.5l-.36.15a5.24,5.24,0,0,0,.08-2.17,7.09,7.09,0,0,0-3.71-4.89,9.16,9.16,0,0,0-4.94-1.49,5.48,5.48,0,0,0-3.25,1.2,13,13,0,0,0-.95.9,2.68,2.68,0,0,1,.82-1.05,5.43,5.43,0,0,1,3.36-1.42A10.6,10.6,0,0,1,612.5,293a6.58,6.58,0,0,1,1.47,3.18,5.75,5.75,0,0,1-.11,2.41l-.08.29-.28-.14c-3.73-1.88-7-3.58-9.3-4.8l-2.69-1.43A5.39,5.39,0,0,1,600.6,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.14,294.18s-.64-1.08.75-2.06a1.7,1.7,0,0,1,2.26-.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.14,294.18a23.78,23.78,0,0,1,2.86-2.34l0,.39a1.28,1.28,0,0,0-.4-.23,1.69,1.69,0,0,0-1.38.22,2.22,2.22,0,0,0-.88.83,2.25,2.25,0,0,0-.16,1.13s-.13-.07-.21-.29a1.41,1.41,0,0,1,0-1,2.46,2.46,0,0,1,1-1.09,2,2,0,0,1,1.79-.3,1.55,1.55,0,0,1,.6.36l.22.21-.26.18A17.28,17.28,0,0,1,581.14,294.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.89,289.59s.65-1.08,2.16-.31,1.13,2,1.13,2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.89,289.59a21.88,21.88,0,0,1,3.4,1.42l-.36.15a1.39,1.39,0,0,0,0-.46,1.67,1.67,0,0,0-.84-1.11,2.31,2.31,0,0,0-1.15-.4,2.15,2.15,0,0,0-1.07.4s0-.15.16-.33a1.4,1.4,0,0,1,.89-.44,2.46,2.46,0,0,1,1.41.35,2.07,2.07,0,0,1,1.11,1.45,1.53,1.53,0,0,1,0,.7l-.08.29-.28-.14A17.43,17.43,0,0,1,607.89,289.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.9,311.53a1.06,1.06,0,0,1-2.1.32,1.06,1.06,0,1,1,2.1-.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.82,299.23a4.42,4.42,0,0,1,0-1.86,12.21,12.21,0,0,1,1.43-4.27,12.6,12.6,0,0,1,2.84-3.49,4.64,4.64,0,0,1,1.57-1,21.19,21.19,0,0,0-4,4.75A20.87,20.87,0,0,0,571.82,299.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.85,299a4,4,0,0,1-.1-1.75,11.41,11.41,0,0,1,3.64-7.44,4,4,0,0,1,1.43-1,15,15,0,0,0-5,10.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.9,290.71a18.2,18.2,0,0,0-4.57-4.2,18.55,18.55,0,0,0-5.87-2,4.44,4.44,0,0,1,1.87,0,11.82,11.82,0,0,1,7.65,4.53A4.49,4.49,0,0,1,618.9,290.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.9,286.38a22.87,22.87,0,0,0-4.19-3.59,22.53,22.53,0,0,0-5.14-2,10.94,10.94,0,0,1,9.33,5.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.23,313.31c-2-10.25-7.61-13.05-15.22-16.6S663.69,285,663.69,285h-4.44s3.3,8.12-4.31,11.67-13.2,6.35-15.23,16.6,3.3,24,3.3,24l18.46-.22,18.47.22S685.26,323.56,683.23,313.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.36,287.3h69.53l-17.58-40.43H642.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.36,287.3l.25-.71.78-2.13,3-8.15c2.64-7.1,6.4-17.25,11-29.51l0-.15h.15l36.76,0h.17l.07.16,6.71,15.43,10.86,25,.16.35h-.39l-50-.13-14.42-.06-3.84,0h-1l-.32,0h1.37l3.9,0,14.5-.07,49.76-.13-.22.35-10.89-25c-2.29-5.29-4.54-10.47-6.7-15.44l.23.16-36.76,0,.2-.14c-4.62,12.17-8.45,22.23-11.12,29.27-1.35,3.51-2.4,6.27-3.13,8.17-.36.93-.64,1.65-.83,2.16S627.36,287.3,627.36,287.3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.54,108.5c-.27,1.42,4.29,31.69,8,45.87s16.71,53.44,19.08,59.33L315,196s-14.11-28.11-15.45-37.14-7.51-24-12.06-33.71-8.05-19.7-8.05-19.7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.59,80.33s-3.25,4-3.95,6.15-2.09,10-2,13.12,3.1,11.65,3.1,11.65l10.65-.38-1.17-4.22s9.82-5.77,9.59-8.21-8-14-8.71-14.63-2.44,0-3.36.7-3.6,4.87-3.6,4.87,1.26-4,1.62-5.45C276.72,80.33,273.59,80.33,273.59,80.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,143.64c5.41,1.24,10,5.47,11.31,10.39a12.17,12.17,0,0,1-5.13,13.13,4.62,4.62,0,0,1,.19,7.19,5.91,5.91,0,0,1-7.85-1.42c.62,2.72-1.59,5.43-4.48,6.1a10.19,10.19,0,0,1-8.47-2.31,15.79,15.79,0,0,1-4.65-7.2l4.52-21.39C367.64,144.24,373.57,142.41,379,143.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.48,175.66a7.77,7.77,0,0,0,2.24-9.71c1.88-1.29,2.2-4.08,1.33-6.19s-2.62-3.7-4.32-5.22a10.47,10.47,0,0,0-9.43-10.87c-1.43-4.6-6.76-6.88-11.57-6.94a12.38,12.38,0,0,1-3.5-.29,19.14,19.14,0,0,1-2.35-1.08c-4.31-2-9.74-.18-12.77,3.47a8.73,8.73,0,0,1-1.55,1.66,11.85,11.85,0,0,1-2.76,1.09,7.51,7.51,0,0,0-4.37,4.47c-.61,1.72-.62,3.75-1.83,5.11a25.58,25.58,0,0,0-2,1.86c-1.56,2.14.35,5.4-.9,7.74-.26.48-.63.88-.93,1.34a4.61,4.61,0,0,0-.67,3.18,6.63,6.63,0,0,1,.29,2.52,7.41,7.41,0,0,1-.91,1.71c-.76,1.39.69,8.1,1.73,9.3l38.28,12.07a7.51,7.51,0,0,0,7.43-4.48,2.82,2.82,0,0,1,.79-1.31,3.34,3.34,0,0,1,1.26-.36c2.87-.57,4.21-3.87,4.8-6.74a3.57,3.57,0,0,1,.38-1.17A4.47,4.47,0,0,1,372.48,175.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,172.36c2.19-6.76.31-15.87-5.42-21.25-3.61-3.39-6.93-4.42-9.08-5.36a16.25,16.25,0,0,0-9.64-.87c-2.26-.15-12.18,4.58-14.94,12.16-3.06,8.42-6.46,18.83-7.33,25.53-1.73,13.47,7.65,18,7.65,18s-7.42,21-7.42,21l29.43-2.3Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,186.21a5.67,5.67,0,0,0-.14-2.73c-.61-1.06-2-.69-3.19-.37s-2,.65-2,.65l.11,2c.27.9.6,2.11,1.46,2.5l.41.16a2.55,2.55,0,0,0,2,0A3.44,3.44,0,0,0,333.84,186.21Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,167.15c.12.28,1.68-.17,3.41.47s2.69,2,3,1.84.06-.52-.34-1.13a4.81,4.81,0,0,0-2.27-1.73,4.53,4.53,0,0,0-2.82-.11C322.31,166.7,322,167,322.05,167.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.16,179.93a12.12,12.12,0,0,0-2.73-1.36c-.44-.18-.84-.4-.83-.73a2.38,2.38,0,0,1,.7-1.26l2.35-3.06c3.31-4.37,5.85-8,5.67-8.15s-3,3.31-6.31,7.68l-2.3,3.09a2.74,2.74,0,0,0-.76,1.71,1.19,1.19,0,0,0,.55.89,3.32,3.32,0,0,0,.74.33A11.58,11.58,0,0,0,330.16,179.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.7,200.57a34.22,34.22,0,0,0,18.65.49s-7.25,7.72-19.78,2.74Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.14,156.09c.17.52,1.62.63,3.17,1.23s2.74,1.41,3.21,1.12c.21-.15.16-.62-.26-1.22a5.11,5.11,0,0,0-2.31-1.67,5,5,0,0,0-2.83-.22C327.41,155.51,327.07,155.84,327.14,156.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.4,175c-.27.15-1.2-1.18-3-1.76s-3.34-.14-3.46-.42c-.06-.12.28-.44,1-.66a4.76,4.76,0,0,1,2.86.07,4.53,4.53,0,0,1,2.27,1.67C345.48,174.47,345.53,174.91,345.4,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.11,163.75c-.48.28-1.7-.59-3.32-1.15s-3.1-.74-3.27-1.27c-.08-.24.28-.57,1-.75a5.35,5.35,0,0,1,2.93.26,5.18,5.18,0,0,1,2.39,1.69C350.27,163.13,350.33,163.6,350.11,163.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,184c.28-1,2.05-2.9,3-2.76,2.65.34,7.14,1.88,5.3,8.32-2.52,8.79-10.83,4.45-10.77,4.19S354.83,187.26,355.81,184Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.73,191.18s.12.15.34.35a1.59,1.59,0,0,0,1.14.35c1-.08,2.23-1.33,2.73-2.9a5.33,5.33,0,0,0,.2-2.32,1.84,1.84,0,0,0-.82-1.5.8.8,0,0,0-1,.16c-.19.21-.18.4-.23.4s-.15-.2,0-.54a1,1,0,0,1,.51-.45,1.2,1.2,0,0,1,.91,0,2.24,2.24,0,0,1,1.21,1.82,5.42,5.42,0,0,1-.17,2.6c-.57,1.76-1.95,3.16-3.33,3.16a1.73,1.73,0,0,1-1.33-.63C356.68,191.4,356.69,191.19,356.73,191.18Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,156.59a5.32,5.32,0,0,0,4.18-3.88c1.07.7,2.71-.46,3.69-1.28s2-1.08,2.29-2.32a1.39,1.39,0,0,1,.3-.69,1.52,1.52,0,0,1,1.12-.27,6.14,6.14,0,0,0,5.07-3,12.88,12.88,0,0,0,5.72,2.76,5,5,0,0,0,8.15,2,4.47,4.47,0,0,0,2.23,2.94,13,13,0,0,0,3.58,1.27,5.26,5.26,0,0,0,1.64,6.68c.28.18.62.39.67.72s-.21.66-.42.94a4.12,4.12,0,0,0,1.17,5.82,3.08,3.08,0,0,0-1.1,4.71c.26.29.61.64.45,1a.89.89,0,0,1-.3.31,6,6,0,0,0-2.24,2.49,2.21,2.21,0,0,0,1,2.86,2.94,2.94,0,0,0-1.68,1.6c-.24.76.3,1.76,1.1,1.69a51.45,51.45,0,0,0,5.23.2c3.47-2.64,1.44-7.28,2.43-11.53a28.43,28.43,0,0,0-.3-13,20.89,20.89,0,0,0-1.87-5.15,27.63,27.63,0,0,0-3.78-5,25.17,25.17,0,0,0-6-5.43c-4.41-2.51-9.84-2.24-14.85-1.5a21.51,21.51,0,0,0-5.6,1.41,19.55,19.55,0,0,0-5.56,4.06,24.38,24.38,0,0,0-5.82,8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58,153a3.56,3.56,0,0,1,.75-.8c.28-.24.64-.5,1-.87a4.28,4.28,0,0,0,1-1.49,12.66,12.66,0,0,0,.6-2.18,10.33,10.33,0,0,1,.84-2.58,7.74,7.74,0,0,1,2-2.43,7.94,7.94,0,0,1,1.45-.92,11.72,11.72,0,0,1,1.69-.62,5.48,5.48,0,0,0,1.67-.76,6.79,6.79,0,0,0,1.32-1.4,12.33,12.33,0,0,1,7.31-4.37,10.72,10.72,0,0,1,2.34-.17,9.83,9.83,0,0,1,2.39.42c.39.12.77.29,1.15.45s.74.37,1.1.55a5.83,5.83,0,0,0,2.35.7c.83.08,1.68,0,2.55.06a15.58,15.58,0,0,1,2.62.3,16,16,0,0,1,2.58.73,13.92,13.92,0,0,1,2.43,1.24,9,9,0,0,1,3.55,4.22l.2.53-.12-.1a10.6,10.6,0,0,1,9.55,11l0-.11a29.54,29.54,0,0,1,2.59,2.53,9.82,9.82,0,0,1,1.85,3,6.37,6.37,0,0,1,.24,3.37,4.29,4.29,0,0,1-1.72,2.71l0-.15a7.62,7.62,0,0,1,.69,5.11,7.8,7.8,0,0,1-2.21,4.08,6.93,6.93,0,0,1-.84.7c-.29.2-.58.39-.83.6a1.94,1.94,0,0,0-.57.77,4.79,4.79,0,0,0-.24.92,15.4,15.4,0,0,1-1.08,3.3,7.4,7.4,0,0,1-1.62,2.28,4.64,4.64,0,0,1-1.78,1c-.54.16-1,.16-1.25.25a3.5,3.5,0,0,0-.4.17,1,1,0,0,1,.39-.2c.27-.11.71-.12,1.24-.29a4.46,4.46,0,0,0,1.73-1,7.06,7.06,0,0,0,1.57-2.26,15.32,15.32,0,0,0,1-3.27,4.76,4.76,0,0,1,.25-.95,2.17,2.17,0,0,1,.6-.84,10.25,10.25,0,0,1,.85-.62,6.49,6.49,0,0,0,.81-.68,7.56,7.56,0,0,0,2.13-4,7.39,7.39,0,0,0-.68-4.95l-.05-.09.08-.06a4.11,4.11,0,0,0,1.62-2.57,6.06,6.06,0,0,0-.25-3.23,9.23,9.23,0,0,0-1.8-2.91,29.15,29.15,0,0,0-2.58-2.5l-.05,0v-.06a10.35,10.35,0,0,0-9.31-10.72h-.09l0-.09-.2-.51a8.67,8.67,0,0,0-3.44-4.09,14,14,0,0,0-2.38-1.21,15.47,15.47,0,0,0-2.53-.73,15.1,15.1,0,0,0-2.58-.29c-.85,0-1.71,0-2.57-.07a6.09,6.09,0,0,1-1.26-.24,6.72,6.72,0,0,1-1.17-.49c-.37-.18-.73-.38-1.1-.55a11.81,11.81,0,0,0-1.12-.44,9.74,9.74,0,0,0-2.32-.41,10.89,10.89,0,0,0-2.29.16A12,12,0,0,0,332,139.1a7.49,7.49,0,0,1-1.37,1.44,6,6,0,0,1-1.73.78,10.62,10.62,0,0,0-1.67.6,7.37,7.37,0,0,0-3.36,3.25,10.26,10.26,0,0,0-.85,2.54,12.7,12.7,0,0,1-.63,2.19,4.22,4.22,0,0,1-1,1.51c-.39.37-.75.62-1,.85a4.39,4.39,0,0,0-.6.55C319.64,152.94,319.59,153,319.58,153Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75,140.52s-.19-.2-.55-.54a6.22,6.22,0,0,0-1.75-1.12,5.73,5.73,0,0,0-3-.44,6.06,6.06,0,0,0-3.33,1.6,5.84,5.84,0,0,0-.73.86,1.17,1.17,0,0,0-.21,1l.13.36L349,142a3.83,3.83,0,0,0-2.81-.48,3.67,3.67,0,0,0-2,1.18,3.92,3.92,0,0,0-.77,1.35c-.12.34-.15.54-.17.54s0,0,0-.15a2.45,2.45,0,0,1,.08-.42,3.7,3.7,0,0,1,.73-1.43,3.79,3.79,0,0,1,2.05-1.3,4,4,0,0,1,3,.49l-.2.15a1.39,1.39,0,0,1,.23-1.17,5.22,5.22,0,0,1,.77-.92,6.15,6.15,0,0,1,3.49-1.65,5.86,5.86,0,0,1,3.12.51,5.57,5.57,0,0,1,1.74,1.23,4.94,4.94,0,0,1,.38.44C358.72,140.46,358.76,140.51,358.75,140.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,154.81a1.38,1.38,0,0,1-.4.22,6.48,6.48,0,0,1-1.19.4,4.37,4.37,0,0,1-1.91,0,3.25,3.25,0,0,1-2-1.3l.2,0-.36.28-.4.26a5.6,5.6,0,0,1-2.6.71,5.67,5.67,0,0,1-2.17-.36,5,5,0,0,1-1.28-.72,2,2,0,0,1-.39-.38,8.5,8.5,0,0,0,1.74.92,6,6,0,0,0,2.09.29,5.51,5.51,0,0,0,2.47-.7l.38-.24.34-.27.13-.1.08.13a3.1,3.1,0,0,0,1.81,1.22,4.48,4.48,0,0,0,1.81.05C369.39,155.06,370,154.76,370,154.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.21,164.32s0,.05-.07.15a1.55,1.55,0,0,1-.32.37,2.45,2.45,0,0,1-1.69.52,4.65,4.65,0,0,1-2.42-1,14.43,14.43,0,0,1-1.22-1,2.54,2.54,0,0,1-.89-1.47v-.15l.19.12a10.31,10.31,0,0,1-3.07.79,4.69,4.69,0,0,1-2.54-.48,3.38,3.38,0,0,1-1.31-1.14,2.47,2.47,0,0,1-.22-.41c0-.11-.05-.16,0-.16s.11.19.35.51a3.51,3.51,0,0,0,1.31,1,4.62,4.62,0,0,0,2.43.4,10.75,10.75,0,0,0,3-.8l.17-.06v.19l0,.13a2.2,2.2,0,0,0,.79,1.3,14.55,14.55,0,0,0,1.19.95,4.5,4.5,0,0,0,2.28,1,2.42,2.42,0,0,0,1.62-.41A3,3,0,0,0,372.21,164.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.77,188.52a2.35,2.35,0,0,0,1.33-.86,5.21,5.21,0,0,0,.46-3.8.9.9,0,0,0-.59-.67,2.74,2.74,0,0,0-1,0c-.69.09-1.31.19-1.83.28a7.59,7.59,0,0,1-1.71.26,4.72,4.72,0,0,1,1.63-.62,17.08,17.08,0,0,1,1.84-.39,2.81,2.81,0,0,1,1.2,0,1.43,1.43,0,0,1,.95,1,5.08,5.08,0,0,1-.67,4.18,1.87,1.87,0,0,1-1.14.69C331.94,188.62,331.77,188.55,331.77,188.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.11,147.89a8.51,8.51,0,0,0-.57-1.75,6.26,6.26,0,0,0-3.62-3.2,5.34,5.34,0,0,0-3.33,0,6.23,6.23,0,0,0-3.06,2.29,4.08,4.08,0,0,0-.65,3.95,1.35,1.35,0,0,0,1.61.85,2.75,2.75,0,0,0,1.57-1.47,5.48,5.48,0,0,0,.2-4.43,5.82,5.82,0,0,0-2.71-3.18,7.86,7.86,0,0,0-7.07-.12,10.67,10.67,0,0,0-3.85,3.14c-.73.94-1,1.54-1.07,1.51a1.74,1.74,0,0,1,.18-.44,10.47,10.47,0,0,1,.73-1.19,10.3,10.3,0,0,1,3.85-3.36,8.22,8.22,0,0,1,7.46,0,6.31,6.31,0,0,1,3,3.42,6,6,0,0,1-.22,4.85,3.23,3.23,0,0,1-1.89,1.73,1.81,1.81,0,0,1-1.35-.16,2.06,2.06,0,0,1-.86-1,3.74,3.74,0,0,1-.22-2.39,5.87,5.87,0,0,1,.94-2.06,6.58,6.58,0,0,1,3.32-2.42,5.63,5.63,0,0,1,3.57,0,6.28,6.28,0,0,1,3.69,3.46A3.89,3.89,0,0,1,392.11,147.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,143.26s0-.11.13-.27a2.09,2.09,0,0,1,.62-.6A2.7,2.7,0,0,1,317,142a2.55,2.55,0,0,1,1.77.5c1.15.87,1.64,2.52,2,4.18.1.42.2.86.31,1.3a4,4,0,0,1,.14,1.46,1.41,1.41,0,0,1-.4.76,1.28,1.28,0,0,1-.83.31,1.91,1.91,0,0,1-1.5-.71,2.75,2.75,0,0,1-.16-3,3,3,0,0,1,2.45-1.42,3.45,3.45,0,0,1,2.42.81,4.26,4.26,0,0,1,1.26,1.83,5.19,5.19,0,0,1,0,3.13,2.73,2.73,0,0,1-.46,1s.12-.39.26-1.09a5.17,5.17,0,0,0-.2-3,4,4,0,0,0-1.18-1.62,3,3,0,0,0-2.12-.67,2.49,2.49,0,0,0-2,1.2,2.23,2.23,0,0,0,.13,2.44,1.37,1.37,0,0,0,1.07.52.71.71,0,0,0,.74-.64,3.37,3.37,0,0,0-.12-1.28c-.1-.43-.19-.86-.29-1.28-.31-1.67-.76-3.22-1.74-4a2.5,2.5,0,0,0-2.74-.19A4.2,4.2,0,0,0,315,143.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.49,139.59a4.25,4.25,0,0,0,.43-1.35,4.2,4.2,0,0,0-1.39-3.45,6.19,6.19,0,0,0-5.48-1,8.71,8.71,0,0,0-3.19,1.31,3.63,3.63,0,0,0-1.79,2.95l-.46-.16a2.8,2.8,0,0,0,.55-2.13,4.07,4.07,0,0,0-2.28-3.13,6.1,6.1,0,0,0-3.76-.33,10.64,10.64,0,0,0-5.71,3.15,6.14,6.14,0,0,0-1.61,4.06,8.22,8.22,0,0,0,.23,1.64,1.47,1.47,0,0,1-.19-.4,4.2,4.2,0,0,1-.24-1.23,6.21,6.21,0,0,1,1.53-4.31,10.87,10.87,0,0,1,5.89-3.38,6.65,6.65,0,0,1,4.08.34,4.56,4.56,0,0,1,2.58,3.53,3.35,3.35,0,0,1-.67,2.52l-.44.54,0-.7a4.13,4.13,0,0,1,2-3.37A9,9,0,0,1,351,133.3a6.5,6.5,0,0,1,5.81,1.23,4.37,4.37,0,0,1,1.34,3.73,2.82,2.82,0,0,1-.38,1Q357.52,139.61,357.49,139.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.58,182.5s-.1-.05-.27-.18a4.73,4.73,0,0,1-.64-.67,5.74,5.74,0,0,1-1.1-3.21,5.36,5.36,0,0,1,2.21-4.46,5.79,5.79,0,0,1,2.83-1.1,2.71,2.71,0,0,1,1.69.23,1,1,0,0,1,.39.95,1.24,1.24,0,0,1-.53.84,2.05,2.05,0,0,1-1.77.1,3.45,3.45,0,0,1-1.39-.93,3.82,3.82,0,0,1-1-2.89,4.22,4.22,0,0,1,1.2-2.49,4.67,4.67,0,0,1,2.07-1.21,5.44,5.44,0,0,1,3.38.23,3,3,0,0,1,1.07.63s-.4-.19-1.14-.43a5.36,5.36,0,0,0-3.21-.08,4.12,4.12,0,0,0-2.9,3.39,3.41,3.41,0,0,0,.89,2.51,3,3,0,0,0,1.17.78,1.55,1.55,0,0,0,1.32,0c.33-.21.43-.75.13-.92a2.41,2.41,0,0,0-1.34-.16,5.41,5.41,0,0,0-2.59,1,5,5,0,0,0-2.13,4.07,5.78,5.78,0,0,0,.9,3.09C351.27,182.18,351.61,182.47,351.58,182.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.51,156.05s-.45-.19-1.27-.44a8.51,8.51,0,0,0-3.55-.28,7.81,7.81,0,0,0-2.35.69,4,4,0,0,0-2,1.72,1.52,1.52,0,0,0,0,1.3,1.38,1.38,0,0,0,1.16.64A3.29,3.29,0,0,0,396,158a6.82,6.82,0,0,0,1.45-2.94,3.44,3.44,0,0,0-.66-2.82,3.93,3.93,0,0,0-2.42-1.15,17.13,17.13,0,0,0-2.48-.18,5,5,0,0,0-3.34,1,5.66,5.66,0,0,0-.86,1,.8.8,0,0,1,.11-.33,2.78,2.78,0,0,1,.61-.81,5.09,5.09,0,0,1,3.47-1.22,16.31,16.31,0,0,1,2.55.13,4.29,4.29,0,0,1,2.72,1.26,3.92,3.92,0,0,1,.81,3.21,7.28,7.28,0,0,1-1.55,3.18,6.46,6.46,0,0,1-1.27,1.29,2.67,2.67,0,0,1-1.75.55,1.88,1.88,0,0,1-1.56-.91,2,2,0,0,1,0-1.73,4.39,4.39,0,0,1,2.31-1.92,7.82,7.82,0,0,1,2.49-.66,8.05,8.05,0,0,1,3.66.45,6.33,6.33,0,0,1,.91.42C401.42,156,401.52,156,401.51,156.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.62,138s-24.79,26.2-31.29,32c-6.17,5.5-31.65,27.61-31.65,27.61l9,25.8s25.3-28.69,30.08-35.15l21.38-28.39c2.91-4.33,12-16.45,12-16.45Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.61,137.79s-.58-5.65-.88-6.94-1.89-5.37-1.49-7.46,3.67-6,5-7.25,3.58-1.69,4.37,0c0,0,2.78.2,3.38,1.29a8.35,8.35,0,0,1,.8,2l3.57-.7s.8,2.09-.59,3.28c0,0,1.79.1,2.08,1.59a9.47,9.47,0,0,1-.69,4.87c-.4.4-2.49,2.19-2.49,2.19s1.2,7.85.3,9.44-7.26,5.86-7.26,5.86Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,129.35c.45.75,1.73,1.68,2.54,1.37a3.17,3.17,0,0,0,1.71-1.86,9.58,9.58,0,0,0,.48-2.55l.25-2.65",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,123.66a5,5,0,0,1,0,1.61c0,.49-.05,1.08-.11,1.73a6.79,6.79,0,0,1-.49,2.14,3.41,3.41,0,0,1-1.51,1.68,1.43,1.43,0,0,1-1.05.14,2.62,2.62,0,0,1-.79-.36c-.87-.59-1.12-1.22-1.06-1.25a9.49,9.49,0,0,0,1.25.94,1.36,1.36,0,0,0,1.43.1,3,3,0,0,0,1.25-1.46,15.83,15.83,0,0,0,.72-3.7A5,5,0,0,1,438,123.66Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.64,122.48a2.35,2.35,0,0,0,1.86-2.11,5.87,5.87,0,0,0-.1,1.82,2,2,0,0,0,.93,1.51,2.11,2.11,0,0,0,2.54-.75c.91-1.18.87-2.81.78-4.3-.06-1.08,0-3-2.08-3.63",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.57,115s.28,0,.72.2a2.53,2.53,0,0,1,1.32,1.56,5.12,5.12,0,0,1,.24,1.4c0,.49.08,1,.08,1.59a4.92,4.92,0,0,1-1.05,3.56,2.59,2.59,0,0,1-1.75.81,1.79,1.79,0,0,1-1.59-.88,2.79,2.79,0,0,1-.4-1.57,8.56,8.56,0,0,1,.17-1.35l.38,0a2.45,2.45,0,0,1-1.24,1.9c-.49.25-.81.23-.81.2s.28-.1.69-.38a2.3,2.3,0,0,0,1-1.74l.38,0a3.81,3.81,0,0,0,.25,2.6,1.32,1.32,0,0,0,1.18.63,2.14,2.14,0,0,0,1.39-.66,4.65,4.65,0,0,0,.94-3.2,14.39,14.39,0,0,0-.19-2.88,2.53,2.53,0,0,0-1.07-1.5A7,7,0,0,1,429.57,115Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.53,128.45a36.34,36.34,0,0,1,5.82-6.55,12.22,12.22,0,0,1,8-3,3.3,3.3,0,0,1-.85,3A16.13,16.13,0,0,1,435,124a5.47,5.47,0,0,0-2.06,2.51c-.44,1.37.06,2.84.34,4.25a14,14,0,0,1-1.3,9.07",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,139.84s.22-.54.56-1.51a14.7,14.7,0,0,0,.79-4.27,13.69,13.69,0,0,0-.22-3,18.16,18.16,0,0,1-.58-3.48,3.94,3.94,0,0,1,.53-1.92,6,6,0,0,1,1.36-1.53,18.36,18.36,0,0,0,3.11-2.62,2.88,2.88,0,0,0,.62-2.56l.24.18A11.25,11.25,0,0,0,432,121a20.44,20.44,0,0,0-4.17,3.59c-1.05,1.16-1.83,2.15-2.39,2.82a8.25,8.25,0,0,1-.88,1,6.33,6.33,0,0,1,.74-1.13c.5-.71,1.25-1.73,2.28-2.94a19.53,19.53,0,0,1,4.17-3.75,11.67,11.67,0,0,1,6.69-2h.18l.05.17a3.43,3.43,0,0,1-.69,3,18.14,18.14,0,0,1-3.2,2.69A4.06,4.06,0,0,0,433,127.6a18,18,0,0,0,.53,3.4,14.22,14.22,0,0,1,.16,3.07,13.65,13.65,0,0,1-1,4.33,11.83,11.83,0,0,1-.52,1.09A1.93,1.93,0,0,1,432,139.84Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.85 227.01 292.45 205.91 313.66 191.52 321.99 208.21 301.85 227.01",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.53,315.11c-6.18-5.84-21.27-21.6-25.85-36.1-.32-1,.79-32.58,1.82-38.07s8.81-15.24,8.81-15.24l-10.63-28.07-11.81,9.45s-5.74,2.19-11.67,4.57c-10.12,2-16.37-5.76-16.37-5.76.74-.42-5.44,2.42-7.19,4.11,0,0-23,21.76-22.67,35.16s3.81,14.69,5.19,24.89c1.34,9.87,5.42,22,6.62,31.6a32.45,32.45,0,0,0,6.15,15.18s2.65,5,11.23,4.69,36.26-6,51.37-1.6,22.29,13.41,22.29,13.41S392.72,321,386.53,315.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.93,269.38a7,7,0,0,1-1.42.07,22,22,0,0,1-3.84-.42,23.94,23.94,0,0,1-18.29-16.18,21.8,21.8,0,0,1-.88-3.76,6,6,0,0,1-.1-1.41,42.58,42.58,0,0,0,1.33,5,24.57,24.57,0,0,0,18,15.94A45.91,45.91,0,0,0,335.93,269.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.21,237.49s-.24-.21-.61-.65a19.38,19.38,0,0,1-1.39-1.94,25.53,25.53,0,0,1-3.81-15.13,17.29,17.29,0,0,1,.31-2.38,3.16,3.16,0,0,1,.22-.85c.09,0-.11,1.25-.16,3.24a28.46,28.46,0,0,0,3.76,14.93C355.52,236.44,356.28,237.43,356.21,237.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.91,237.83a5.26,5.26,0,0,1,.38-1.16c.26-.74.71-1.78,1.31-3a54.93,54.93,0,0,1,5.73-9.3c2.59-3.41,5.16-6.29,7-8.4l2.19-2.48a5.56,5.56,0,0,1,.85-.87,5,5,0,0,1-.69,1c-.48.63-1.18,1.51-2.06,2.59-1.76,2.17-4.29,5.09-6.85,8.47a64.45,64.45,0,0,0-5.82,9.16C293.65,236.26,293,237.86,292.91,237.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.28,308.88a14.73,14.73,0,0,1-1.78-.07,24.51,24.51,0,0,0-4.8.33,38.25,38.25,0,0,0-6.9,1.84c-2.54.91-5.26,2.09-8.13,3.33a70.44,70.44,0,0,1-8.27,3.08,30.42,30.42,0,0,1-7.11,1.27,19.59,19.59,0,0,1-4.86-.35c-.57-.1-1-.26-1.28-.33a1.71,1.71,0,0,1-.44-.16,26.55,26.55,0,0,0,6.56.47,31.77,31.77,0,0,0,7-1.36,76.07,76.07,0,0,0,8.21-3.1c2.86-1.24,5.61-2.41,8.18-3.3a36.34,36.34,0,0,1,7-1.76,22.13,22.13,0,0,1,4.86-.16,12.62,12.62,0,0,1,1.32.17A1.52,1.52,0,0,1,371.28,308.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.83,263.34c-4-3.4-7.55-7.72-8-12.93l-.29,0a17.33,17.33,0,0,0,5.37,16.37c4.52,4,10.51,4.65,16.19,2.63C328,268.19,323.81,266.74,319.83,263.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M307.89,315A215.55,215.55,0,0,0,279.3,310c-11-.9-37-.54-41.8,6.27s-4.29,13.09-2.61,17.75,16.61,13.27,23.32,17.39,45.9,5.56,45.9,5.56l16.05-38.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.54,319.75c-.94.08-17.22.85-21.69,7.69s-9,15.22-9.15,20.18,2.62,8.21,7.84,9.92,23.88,2,31,1,41.68-7.2,49.15-10.45,9.47-10.21,5.57-20.14c-3.07-7.81-18-9.44-26.35-11.83S329.54,319.75,329.54,319.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.85,323.32a10.57,10.57,0,0,1,1.77.13c.57.05,1.27.14,2.07.27s1.72.25,2.73.44c2,.34,4.39.89,7,1.55s5.47,1.55,8.41,2.58,5.7,2.19,8.17,3.31,4.63,2.24,6.4,3.27c.9.49,1.69,1,2.38,1.41s1.28.8,1.75,1.13a11.79,11.79,0,0,1,1.43,1,10.68,10.68,0,0,1-1.54-.88c-.48-.3-1.08-.65-1.79-1.05s-1.5-.87-2.41-1.34c-1.78-1-4-2-6.42-3.16s-5.21-2.2-8.14-3.25-5.77-1.89-8.37-2.61-5-1.26-7-1.65c-1-.21-1.91-.38-2.71-.52s-1.48-.27-2-.35A13.15,13.15,0,0,1,257.85,323.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.94,336.38a8.89,8.89,0,0,1-1.15-1c-.71-.67-1.77-1.6-3.11-2.7s-3-2.35-4.92-3.63a63.2,63.2,0,0,0-6.47-3.73,64.67,64.67,0,0,0-6.89-2.89,59.37,59.37,0,0,0-5.86-1.71c-1.7-.41-3.08-.69-4-.84a8.07,8.07,0,0,1-1.49-.32,9.38,9.38,0,0,1,1.52.12,39.2,39.2,0,0,1,4.09.68,54.81,54.81,0,0,1,5.93,1.61A55.27,55.27,0,0,1,375,328.66a52.73,52.73,0,0,1,4.88,3.74,38.32,38.32,0,0,1,3,2.85A7.71,7.71,0,0,1,383.94,336.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.91,332.56l-.2-.14-.54-.43-2.07-1.69a78.38,78.38,0,0,0-7.88-5.82,39.86,39.86,0,0,0-6-3.09,34.93,34.93,0,0,0-7.46-2c-5.39-.87-11.44-.76-17.75-.61s-12.34.65-17.78,1.25c-2.72.31-5.31.63-7.71,1a24.49,24.49,0,0,1-6.79.56,12.12,12.12,0,0,1-5.3-1.87,18,18,0,0,1-3.34-2.63,9.94,9.94,0,0,1-1.63-2.13,4.32,4.32,0,0,1-.39-.85s.15.29.48.8a10.63,10.63,0,0,0,1.69,2,18.31,18.31,0,0,0,3.34,2.52,12,12,0,0,0,5.18,1.75,24.54,24.54,0,0,0,6.69-.61c2.41-.39,5-.73,7.72-1,5.46-.63,11.48-1.1,17.82-1.3s12.4-.25,17.85.66a34.53,34.53,0,0,1,7.54,2.09,38.44,38.44,0,0,1,6,3.18,71.34,71.34,0,0,1,7.82,6c.85.75,1.51,1.34,2,1.77l.51.47A1,1,0,0,1,391.91,332.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.52,319.83a2.73,2.73,0,0,1-.62.15c-.41.08-1,.16-1.79.32a59.57,59.57,0,0,0-6.48,1.62,57.24,57.24,0,0,0-19.26,10.33c-3.31,2.7-6.12,5.83-7.45,9.28a14.74,14.74,0,0,0-.24,9.61,22.89,22.89,0,0,0,2.83,6c.87,1.31,1.43,2,1.39,2a3.68,3.68,0,0,1-.44-.47c-.27-.31-.65-.79-1.12-1.44a21.46,21.46,0,0,1-3-6,16.93,16.93,0,0,1-.78-4.6,14.15,14.15,0,0,1,.92-5.28c1.35-3.58,4.22-6.78,7.57-9.51a55.27,55.27,0,0,1,19.49-10.28,50.34,50.34,0,0,1,6.54-1.47c.78-.13,1.4-.18,1.81-.23A4.38,4.38,0,0,1,333.52,319.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.49,313.86c-2.09-1.5-4.9-1.44-7.46-1.16a109.76,109.76,0,0,0-23.8,5.1c10.63-1.79,21.27-3.3,31.07-2.64a.72.72,0,0,0,.61-.22C375.2,314.61,374.85,314.12,374.49,313.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M544.65,329.13c-.87-4.37-3.43-8.24-6.39-11.57-10.52-11.83-26.44-17.94-42.24-19s-31.57,2.56-46.57,7.64c-8.48,2.87-17.13,6.44-23.11,13.1s-8.5,17.24-3.57,24.72l6.63,1.24-3.18.14a987,987,0,0,0,102.2-.43c4.46-.25,9.27-.67,12.63-3.6S545.51,333.51,544.65,329.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,313.56a4.25,4.25,0,0,1,.32.88c.18.57.4,1.41.65,2.46a55.6,55.6,0,0,1,1.2,16.67c-.09,1.07-.19,1.94-.29,2.53a2.81,2.81,0,0,1-.2.91,32.69,32.69,0,0,1,.12-3.46A72.81,72.81,0,0,0,502.6,317,31.71,31.71,0,0,1,502,313.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.11,314a2.8,2.8,0,0,1-.61,0l-1.73-.22c-1.51-.21-3.69-.46-6.39-.73s-5.92-.51-9.5-.67-7.53-.17-11.66,0-8.07.44-11.64.81-6.76.82-9.44,1.27-4.83.84-6.32,1.15l-1.72.32a2.47,2.47,0,0,1-.61.08,3.51,3.51,0,0,1,.59-.18l1.7-.42c1.47-.37,3.63-.82,6.3-1.31s5.88-1,9.45-1.39,7.52-.7,11.67-.85,8.11-.06,11.7.09,6.82.46,9.52.78,4.88.63,6.38.9l1.72.31A2.32,2.32,0,0,1,494.11,314Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.92,313.63a21.48,21.48,0,0,1-3.09-.2c-1.9-.16-4.53-.33-7.44-.39s-5.55,0-7.45.1a21.61,21.61,0,0,1-3.1.07,16.43,16.43,0,0,1,3.07-.44,70.15,70.15,0,0,1,15,.3A15.06,15.06,0,0,1,526.92,313.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.26 481.41 82.74 481.41 79.85 431.66 92.5 431.66 90.26 481.41",
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.56 481.41 231.05 481.41 228.15 425.22 240.8 425.22 238.56 481.41",
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.18 481.41 537.66 481.41 534.77 417.65 547.42 417.65 545.18 481.41",
    style: {
      fill: "#b56d50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.46,343.35H547.91a11.92,11.92,0,0,1,11.92,11.92v48.22a14.17,14.17,0,0,1-14.17,14.17H58.5a0,0,0,0,1,0,0V363.31a20,20,0,0,1,20-20Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "409.72 417.84 418.14 417.65 411.83 343.88 400.84 343.31 409.72 417.84"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,422.27V355.88a16.33,16.33,0,0,1,16.28-16.3l104.86-.47s12.94-13,22.19-12.92,16.64-22.46,46.45-22.52c33.71-.07,25.31,9.63,43.73,15.9s45.44-7,62.36,6.62,43.41,5.8,49,17.69,6.78,81.34,6.78,81.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,408.72v13.55c-.43,12,2.13,12.52,7.59,14.66s11.58.66,17.1-1.32,11.06-4.48,16.89-4.34c11.7.28,21.45,11,33.15,11.16,15,.17,26.78-17,41.69-15.55,11.34,1.09,20.49,12.89,31.83,11.79,7.91-.76,14.22-7.72,22.06-9,10.13-1.69,19.38,6.29,29.53,7.8,13.74,2,27.05-8,40.86-6.56,11.88,1.2,22,10.66,33.87,11.65,14.94,1.24,28.68-11.09,43.6-9.73,12.42,1.13,23.09,11.62,35.55,11.24l-2.38-29.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89,424.81c-.14,0-.26-17.16-.26-38.33s.12-38.34.26-38.34.26,17.16.26,38.34S248,424.81,247.89,424.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.33,340.63s-.15,0-.46,0l-1.34,0-5.17.05-19,.08-62.72.07-62.73-.07-19-.08-5.17-.05-1.35,0-.45,0,.45,0,1.35,0,5.17-.05,19-.08,62.73-.08,62.72.08,19,.08,5.17.05,1.34,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.72,321.51c0,.1-2-.11-5.28.08a42.64,42.64,0,0,0-5.66.74,41.2,41.2,0,0,0-13,5,43.57,43.57,0,0,0-4.69,3.25c-2.54,2-3.9,3.55-4,3.48a6.75,6.75,0,0,1,.92-1.09,15.82,15.82,0,0,1,1.17-1.19c.47-.44,1-1,1.64-1.48a36.86,36.86,0,0,1,4.68-3.38,39.51,39.51,0,0,1,13.13-5.06,37.78,37.78,0,0,1,5.73-.64c.82-.05,1.57,0,2.22,0a15.13,15.13,0,0,1,1.67.1A6.38,6.38,0,0,1,286.72,321.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.72,343.31c0,.14-18.71.05-41.78-.2s-41.78-.57-41.78-.71,18.71-.06,41.79.19S392.72,343.16,392.72,343.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.84,432.12c-.14,0-1.59-17.52-3.22-39.15s-2.86-39.19-2.71-39.2,1.59,17.52,3.22,39.16S401,432.11,400.84,432.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,390.67c.15,0-.06,8.84-.45,19.73s-.84,19.73-1,19.72.06-8.84.46-19.73S124,390.66,124.17,390.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.54,427.88c-.14,0-.26-13.66-.26-30.49s.12-30.49.26-30.49.26,13.65.26,30.49S140.69,427.88,140.54,427.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.08,421.61a1.64,1.64,0,0,1-.13-.48c-.06-.38-.15-.84-.25-1.39-.21-1.22-.49-3-.8-5.16-.63-4.36-1.37-10.4-2-17.1s-.9-12.78-1-17.18c-.07-2.2-.1-4-.11-5.21v-1.42a1.77,1.77,0,0,1,0-.5,1.78,1.78,0,0,1,.07.49c0,.39.05.86.09,1.42.07,1.31.16,3.07.27,5.21.23,4.39.6,10.46,1.19,17.15s1.27,12.73,1.8,17.09l.64,5.18c.06.56.12,1,.16,1.41A1.66,1.66,0,0,1,187.08,421.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.88,428.32s-.1-.15-.24-.46l-.6-1.36c-.51-1.18-1.18-2.92-1.94-5.1s-1.56-4.8-2.33-7.75-1.45-6.24-2-9.71-.86-6.82-1-9.86-.2-5.8-.14-8.1.17-4.16.31-5.45l.15-1.47a1.74,1.74,0,0,1,.09-.51,2.59,2.59,0,0,1,0,.52c0,.39,0,.88-.05,1.48-.07,1.28-.12,3.14-.14,5.44s.06,5,.24,8.06.56,6.34,1.09,9.81,1.23,6.72,1.94,9.67,1.5,5.57,2.22,7.75,1.33,3.94,1.78,5.15l.5,1.39A2.72,2.72,0,0,1,202.88,428.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,377.22c.15,0-.76,11.57-2,25.82s-2.4,25.79-2.54,25.77.76-11.57,2-25.82S284,377.21,284.11,377.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.56,424.29a1.74,1.74,0,0,1-.2-.51c-.14-.4-.3-.89-.5-1.49-.43-1.31-1-3.21-1.61-5.57a148.85,148.85,0,0,1-3.62-18.78,145.73,145.73,0,0,1-1.13-19.09c0-2.45.09-4.43.18-5.8,0-.63.08-1.15.11-1.57a2.22,2.22,0,0,1,.07-.55,2.13,2.13,0,0,1,0,.56c0,.41,0,.93,0,1.57,0,1.37,0,3.34,0,5.79a166.79,166.79,0,0,0,1.28,19,170,170,0,0,0,3.46,18.76c.58,2.37,1.08,4.28,1.45,5.6.16.61.29,1.12.4,1.52A2.2,2.2,0,0,1,309.56,424.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.87,427.87c-.14,0-.89-9.92-1.66-22.17s-1.29-22.2-1.15-22.21.89,9.92,1.67,22.18S364,427.86,363.87,427.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.59,343.35c0,.14-32.28.26-72.08.26s-72.08-.12-72.08-.26,32.27-.26,72.08-.26S548.59,343.2,548.59,343.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.14,321.45a2.78,2.78,0,0,0-2-1.73,45.37,45.37,0,0,0-18.42-.27,32.81,32.81,0,0,0-17.36,9.39c-1.16,1.24-2.28,2.76-1.71,4.59a4.22,4.22,0,0,0,4.16,2.8,11.53,11.53,0,0,0,6.76-2.58l5.57-5.17c7.35-5.74,20.66-7.61,23-7Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEarlyMorning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/early-morning.2bb7077c81385d3833b33a16ccf68c91.svg";